<div *ngIf="isLoading" class="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm">
  <i class="fas fa-spinner fa-spin text-6xl" style="color:#c19725;"></i>
</div>
<div class="w-full py-3 px-4">
  <div class="sm:flex items-center justify-between mb-4">
    <div class="flex items-center justify-start gap-1 lg:gap-2 mb-3 lg:mb-0">
      <svg
        class="size-6"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_848_1764"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <rect width="24" height="24" fill="#C19725" />
        </mask>
        <g mask="url(#mask0_848_1764)">
          <path
            d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z"
            fill="#C19725"
          />
        </g>
      </svg>
      <img
        class="size-6 sm:size-8 lg:size-10"
        src="https://img.icons8.com/?size=64&id=687TVrPIRrPy&format=png"
        alt="User"
      />
      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444"
        >Assembly Brand</span
      >
    </div>
  </div>

  <div
    class="w-full p-4 mb-4 bg-white rounded-md shadow border border-gray-200"
  >
    <!-- Flex wrapper for two sections -->
    <div class="flex flex-col lg:flex-row gap-6">
      <!-- Utility Section: Add New Category -->
      <div class="flex-1 bg-white rounded-md">
        <h3 class="text-lg font-medium text-center text-[#c19725] mb-4">
          Add New Brand
        </h3>
        <div
          class="max-w-xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <input
            type="text"
            [(ngModel)]="newBrandName"
            name="newBrandName"
            autocomplete="off"
            placeholder="Enter Brand Name"
            class="flex-1 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#c19725] focus:border-[#c19725] text-sm"
            (keydown)="allowOnlyLetters($event)"
            (input)="sanitizeBrandName()"
          />
          <button
            type="button"
            (click)="saveBrandName()" title="For Add Brand Click Here"
            class="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md shadow hover:bg-c19725 transition"
          >
            Add Brand
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="w-full py-3 px-4" *ngIf="brandList.length > 0">
  <p class="font-semibold text-sm sm:text-base lg:text-xl text-444 mb-4">Brands List</p>

  <div class="overflow-x-auto whitespace-nowrap hide-scrollbar mt-4">
    <table class="w-full table bg-white border border-[#D9D9D9] overflow-hidden">
      <thead class="bg-[#F1F8FF] border border-[#0C447D] text-444 text-xs sm:text-xs">
        <tr>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">No.</th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">Brand name</th>
          <th class="p-2 font-medium text-center border-r border-[#0C447D]">Action
        </tr>
      </thead>
      <tbody class="text-xs sm:text-xs" *ngIf="brandList.length > 0">
        <tr
          class="odd:bg-white even:bg-[#F2F2F2] text-[#5A5959]" *ngFor="let brand of paginatedBrandList; let i = index"
        >
          <td class="p-3 text-center">{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>
          <td class="p-3 text-center">{{ brand.assembly_brand_name }}</td>
          <td class="p-3 text-center">
            <button aria-label="Delete Firm" class="icon-btn text-[#BB0000] hover:scale-110 hover:text-[#990000]"
                (click)="deleteBrang(brand.id)" title="Delete Brand {{ brand.assembly_brand_name }}">
                <svg class="w-5 h- md:w-6 md:h-6" fill="none" viewBox="0 0 24 25">
                  <path d="M10 12.5V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M14 12.5V17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M4 7.5H20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M6 10.5V18.5C6 20.1569 7.34315 21.5 9 21.5H15C16.6569 21.5 18 20.1569 18 18.5V10.5"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9 5.5C9 4.39543 9.89543 3.5 11 3.5H13C14.1046 3.5 15 4.39543 15 5.5V7.5H9V5.5Z"
                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- Advanced Pagination Footer -->
    <div class="bg-gray-50/50 px-6 py-4 border-t border-gray-100 flex flex-wrap justify-between items-center gap-4 mt-4">
      
      <!-- Rows per page and page info -->
      <div class="flex items-center gap-4">
        <div class="flex items-center gap-2">
          <label class="text-[10px] font-extrabold text-gray-400 uppercase tracking-widest">Rows:</label>
          <select [(ngModel)]="itemsPerPage" (change)="currentPage=1; updatePagination()"
            class="bg-white border border-gray-200 rounded-xl px-2 py-1.5 text-[11px] font-bold text-[#0C447D] focus:outline-none focus:ring-4 focus:ring-blue-100/50 focus:border-blue-400/50 transition-all cursor-pointer">
            <option [value]="5">5</option>
            <option [value]="10">10</option>
            <option [value]="20">20</option>
            <option [value]="50">50</option>
            <option [value]="100">100</option>
          </select>
        </div>
        <span class="text-[10px] font-extrabold text-gray-400 uppercase tracking-widest">
          Showing {{ (currentPage - 1) * itemsPerPage + 1 }} to {{ (currentPage - 1) * itemsPerPage + paginatedBrandList.length }} of {{ brandList.length }} brands
        </span>
      </div>

      <!-- Numbered Pagination Controls -->
      <div class="flex items-center gap-2">
        <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
          class="w-8 h-8 flex items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-500 hover:bg-gray-50 transition-all disabled:opacity-20 disabled:cursor-not-allowed group">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 group-hover:-translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <div class="flex gap-1.5">
          <ng-container *ngFor="let page of pageNumbers">
            <button *ngIf="page !== '...'; else ellipsis" (click)="goToPage(page)"
              [class]="currentPage === page ? 'bg-[#0C447D] text-white border-[#0C447D] shadow-[0_4px_12px_rgba(12,68,125,0.25)] scale-110' : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50 hover:border-gray-300'"
              class="min-w-[32px] h-8 px-2 flex items-center justify-center rounded-xl border text-[11px] font-bold transition-all duration-200">
              {{ page }}
            </button>
            <ng-template #ellipsis>
              <span class="w-8 h-8 flex items-center justify-center text-gray-300 font-bold">...</span>
            </ng-template>
          </ng-container>
        </div>

        <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
          class="w-8 h-8 flex items-center justify-center rounded-xl border border-gray-200 bg-white text-gray-500 hover:bg-gray-50 transition-all disabled:opacity-20 disabled:cursor-not-allowed group">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
    </div>
</div>
</div>
